// FilterBuilder condition state -> sqlize-query `where` object for
// GET /approval-requests. All the logic lives in the shared factory; this file
// only binds it to the approvals column allow-list.

import { createWhereSerializer } from '../serializeWhereFactory';
import { ALLOWED_FIELDS } from './constants';

export const { serializeWhere, toWhereQuery } =
  createWhereSerializer(ALLOWED_FIELDS);
